import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Import the 6 section components
import SristiANI from "../components/AboutOrgavitaz/SristiANI";
import LearnVitamins from "../components/AboutOrgavitaz/LearnVitamins";
import LearnOrgavitaz from "../components/AboutOrgavitaz/LearnOrgavitaz";
import ScienceBehind from "../components/AboutOrgavitaz/ScienceBehind";

export default function AboutOrgavitaz() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeSection, setActiveSection] = useState("sristi");

  const componentsMap = {
    sristi: <SristiANI />,
    learnVitamins: <LearnVitamins />,
    learnOrgavitaz: <LearnOrgavitaz />,
    scienceBehind: <ScienceBehind />,
  
  };

  const sectionsButtons = [
    { id: "sristi", label: "Sristi ANI & Orgavitaz" },
    { id: "learnVitamins", label: "Learn Vitamins" },
    { id: "learnOrgavitaz", label: "Learn Orgavitaz" },
    { id: "scienceBehind", label: "Science Behind" },
  ];

  return (
    <div>
      {/* Banner Section */}
     

      {/* Section Buttons */}
      <div
        className="d-flex justify-content-center flex-wrap gap-2 sticky-top"
        style={{
          background: "#fff",
          padding: "1rem",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          zIndex: 10,
        }}
      >
        {sectionsButtons.map((section) => (
          <button
            key={section.id}
            className={`btn ${
              activeSection === section.id ? "btn-success text-white" : "btn-outline-success"
            }`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.label}
          </button>
        ))}
      </div>

      {/* Active Section */}
      <div className="container my-5">{componentsMap[activeSection]}</div>
    </div>
  );
}
